import React from 'react'
import { FormWarning } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'
import Container from '../../../../components/Container'

const WarningCreate = (): JSX.Element => {
  return (
    <Container
      pageTitle={nameActions.create.name}
      breadcrumb={breadcrumbCreate}
      tools={toolsCreate}
    >
      <FormWarning typeForm="create" />
    </Container>
  )
}
export default WarningCreate
